import { usePrimitiveT } from "../i18n/I18nProvider.tsx";
import { color as colorVar, size as sizeVar, type ColorToken } from "./tokens.ts";

export type SpinnerProps = {
  size?: "icon.sm" | "icon.md" | "icon.lg";
  /** Default text.secondary. */
  color?: ColorToken;
  /** Announced name (default "Loading…"). */
  accessibilityLabel?: string;
  testID?: string;
};

/** Indeterminate activity. iOS `ProgressView()`, Android `CircularProgressIndicator()`. */
export function Spinner({ size = "icon.md", color = "text.secondary", accessibilityLabel, testID }: SpinnerProps) {
  const t = usePrimitiveT();
  return (
    <span
      className="b-spinner b-spinner-sized"
      role="status"
      aria-label={accessibilityLabel ?? t("common.loading")}
      data-testid={testID}
      style={{ width: sizeVar(size), height: sizeVar(size), color: colorVar(color) }}
    />
  );
}
